import apiClient from './client';

export async function getProperties() {
  const res = await apiClient.get('/api/v1/properties');
  return res.data;
}